import { AgGridSolidRef } from '@ag-grid-community/solid';
import { ExcelSheetIcon } from '@assets';
import { Box } from '@atgfr8/atg-ui-tailwind';
import { Button } from '@components/Button';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { Accessor, Component } from 'solid-js';

export type ProductCatalogActionsButtonProps = {
  setEdit: (value: boolean) => void;
  openModal: (modalName: string) => void;
  gridRef: Accessor<AgGridSolidRef | null>;
};

export const ProductCatalogActionsButton: Component<
  ProductCatalogActionsButtonProps
> = (props) => {
  return (
    <Box class="flex justify-between items-center bg-[#F8F8F8] border border-[#BABFC7] p-4">
      <Box>
        <Button
          variant="contained"
          label="Add Product"
          type="button"
          onClick={() => {
            props.setEdit(false);
            props.openModal('addEditProductDetails');
          }}
          dataTestId={formatDataTestId('Add Product', 'button')}
        />
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <Button
          variant="contained"
          label="Import"
          type="button"
          class="bg-[#E0E0E0]! text-black!"
          onClick={() => {
            props.openModal('importProductCatalog');
          }}
          dataTestId={formatDataTestId('Import', 'button')}
        />
        <Button
          startIcon={
            <img src={ExcelSheetIcon} height="18px" alt="Excel Sheet" />
          }
          variant="contained"
          label="Export Excel"
          type="button"
          onClick={() => {
            props.gridRef()?.api.exportDataAsExcel({
              fileName: 'ProductCatalog.xlsx',
            });
          }}
          class="bg-[#E0E0E0]! text-black!"
          dataTestId={formatDataTestId('Export Excel', 'button')}
        />
      </Box>
    </Box>
  );
};
